import { render, staticRenderFns } from "./hdCampusTV.vue?vue&type=template&id=2ed5ccfc&scoped=true"
import script from "./hdCampusTV.vue?vue&type=script&lang=js"
export * from "./hdCampusTV.vue?vue&type=script&lang=js"
import style0 from "./hdCampusTV.vue?vue&type=style&index=0&id=2ed5ccfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed5ccfc",
  null
  
)

export default component.exports